import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table} from "react-bootstrap";
import { FaRegEdit, FaSearch, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataValorExibicao } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import { getCurrentUser } from '../../common/utils';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import moment from 'moment-timezone';
import FiltrosDinamicos from "./FiltrosDinamicos";

class Relatorios extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listRegistros: [],
            error: "",
            loading: false,
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_modelo: '',
            filtro_modelo_nome: '',
            aba_selecionada: 0,
            filtros_config: '',
            filtros_valores: {},
            all_filtros: {},
            filtros_key: 0,
        };

    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        let ambiente_programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : '';

        this.setState({
            filtro_programa_id: ambiente_programa_id
        }, () => {
            this.gerarRelatorio()
        })
    }

    getDadosForm(formato){
        let dados_usuario = getCurrentUser();    
        const formData = new FormData();

        formData.append("modelo", this.state.filtro_modelo);
        formData.append("formato", formato);

        // filtros
        for (const [key, value] of Object.entries(this.state.filtros_valores)) {
            if (key == "patologia" || key == 'medico_solicitante') {
                formData.append(key, value ? String(value.label) : "");
            } 
            else if (key == 'atendente_id'){
                formData.append(key, value ? value.value : "");
            }
            else {
                formData.append(key, value);
            }
        }

        if(dados_usuario.operador_id) {
            formData.append("atendente_id", dados_usuario.operador_id)
        }

        return formData
    }

    gerarRelatorio(){
        const MySwal = withReactContent(Swal);

        let dados_usuario = getCurrentUser();        

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario
        })

        if(!this.state.filtro_modelo || !this.state.filtro_programa_id){
            return
        }

        const formData = this.getDadosForm("json")

        // Mostra o loading
        MySwal.fire({
            title: 'Gerando relatório...',
            text: 'Por favor, aguarde enquanto o relatório é processado.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        api.post('/relatorios/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            Swal.close();
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            Swal.close();
            let erro_msg = 'Erro ao gerar o relatório, tente novamente.';

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    filtrarRelatorio = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.gerarRelatorio()
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'filtro_programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
            }), () => {
                
            });
        }
        else if (fieldName === 'filtro_modelo') {
            const novoModeloId = event?.value || null;
            const novoModeloNome = event?.label || null;
            const novaConfig = novoModeloId ? (this.state.all_filtros[novoModeloId] || null) : null;

            this.setState(prev => ({
                filtro_modelo: novoModeloId,
                filtro_modelo_nome: novoModeloNome,
                filtros_config: novaConfig,         // pode ser objeto ou null
                filtros_valores: {},                // zera valores dos filtros
                filtros_key: prev.filtros_key + 1,  // força remontagem do FiltrosDinamicos
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    carregaProgramas = async (inputValue) => {
        try {
            let response;   
            response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => {
                if (programa.id === parseInt(this.state.ambiente_programa_id)) {
                    this.setState({
                        filtro_programa_id: programa.id,
                        filtro_programa_nome: programa.nome
                    });
                }
                return {
                    value: programa.id,
                    label: programa.nome
                };
            });
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregaModelos = async (inputValue) => {
        if(!this.state.filtro_programa_id){
            return [];
        }

        try {
            let response;   
            response = await api.get(`/relatorios/modelos/?programa_id=${this.state.filtro_programa_id}&nome=${inputValue}`);

            let all_filtros = {}
            const opcoes = response.data.results.map(modelo => {
                // salva todos os filtros
                if(modelo.filtros){
                    all_filtros[modelo.id] = modelo.filtros
                }

                return {
                    value: modelo.id,
                    label: modelo.nome
                };
            });

            this.setState({
                all_filtros: all_filtros
            })
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar os modelos:', error);
            return [];
        }
    };

    renderResultados = () => {              
        if('resultados' in this.state.listRegistros){
            const resultados = this.state.listRegistros.resultados

            // Pega a lista independente do nome da chave
            const lista = Object.values(resultados)[this.state.aba_selecionada];
            const nomeChave = Object.keys(resultados)[this.state.aba_selecionada];

            if (!lista || lista.length === 0) {
                return <p className="mt-4 text-center">Nenhum dado encontrado</p>;
            }
            
            // Pega os campos do primeiro item
            const campos = Object.keys(lista[0]);
            const campos_map = this.state.listRegistros.campos_map[nomeChave]
            
            return (
                <Table responsive className="custom-table mt-3">
                    <thead>
                        <tr>
                            {campos.map(campo => (
                                <th key={campo}>{campos_map[campo]}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                {campos.map(campo => (
                                    <td key={campo}>{formataValorExibicao(item[campo]) || '-'}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            );
        }  
    };

    renderAbas = () => {            
        if('resultados' in this.state.listRegistros){
            const resultados = this.state.listRegistros.resultados
            const abas = Object.keys(resultados);

            return abas.map((aba, index) =>
                <Button 
                    key={`btnAba_${index}`}
                    type="button" 
                    className="mt-2" 
                    variant={(index == this.state.aba_selecionada) ? "success" : "outline-success"} 
                    size="sm"
                    onClick={() => this.trocarAba(index)}
                >
                    {aba}
                </Button>
            );
        }  
    };

    limpaFiltro = () => {
        this.setState({
            filtros_valores: '',
            filtro_programa_id: null,
            filtro_programa_nome: '',       
            filtro_modelo: ''     
        }, () => {
            this.gerarRelatorio(); // Chama a função para consultar registros com os filtros limpos
        });
    };

    trocarAba = (index) => {        
        this.setState({
            aba_selecionada: index
        }, () => {
            this.renderResultados()
        });
    };

    exportarExcel = () => {
        const MySwal = withReactContent(Swal);
        
        let dados_usuario = getCurrentUser();        

        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario
        })

        if(!this.state.filtro_modelo || !this.state.filtro_programa_id){
            alert('Escolha um modelo antes de continuar');
            return
        }

        const formData = this.getDadosForm("xlsx")

        // Mostra o loading
        MySwal.fire({
            title: 'Gerando relatório...',
            text: 'Por favor, aguarde enquanto o relatório é processado.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        api.post('/relatorios/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob' // Importante: define que a resposta é binária
        })
        .then(response => {
            // Cria um Blob com os dados recebidos
            const blob = new Blob([response.data], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Cria uma URL temporária para o Blob
            const url = window.URL.createObjectURL(blob);
            
            // Cria um elemento <a> temporário
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.state.filtro_modelo_nome}.xlsx`; // Nome do arquivo

            MySwal.close();
            
            // Adiciona ao DOM, clica e remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Libera a URL temporária da memória
            window.URL.revokeObjectURL(url);
        })
        .catch(error => {
            MySwal.close();

            let erro_msg = 'Erro ao gerar o relatório, tente novamente.';

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    };

    handleFiltersChange = (values) => {
        this.setState({ filtros_valores: values });
    };

    render() {        
        if (!hasPerm('pode_gerar_relatorio')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Relatórios</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>Selecione o modelo desejado de relatório e clique em "Filtrar"</h4>
                        <Form method="get" onSubmit={this.filtrarRelatorio}>
                            <Row>
                                {dados_usuario['ambiente_programa_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect          
                                            key={this.state.programa_select_key}                                  
                                            cacheOptions
                                            loadOptions={this.carregaProgramas}
                                            defaultOptions
                                            name="filtro_programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}

                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Modelo</Form.Label>
                                        <AsyncSelect          
                                            key={`kmodelo-${this.state.filtro_programa_id}`}  // Muda a key quando o programa mudar
                                            cacheOptions
                                            loadOptions={(inputValue) => this.carregaModelos(inputValue)}
                                            defaultOptions
                                            name="filtro_modelo"
                                            placeholder={'Buscar modelo...'}
                                            noOptionsMessage={() => "Nenhum modelo encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_modelo')}
                                            value={this.state.filtro_modelo ? { value: this.state.filtro_modelo, label: this.state.filtro_modelo_nome } : null}
                                        />                                        
                                    </Form.Group>
                                </Col>    
                                {
                                this.state.filtros_config &&
                                <FiltrosDinamicos
                                    key={this.state.filtros_key}
                                    config={this.state.filtros_config}
                                    onChange={this.handleFiltersChange}
                                    programa_id={this.state.filtro_programa_id}
                                />
                                }                           
                            </Row>                                                         
                            <Row>
                                <Col sm={6}>
                                    <Button type="submit" variant="secondary" size="sm">
                                        <FaSearch /> Filtrar
                                    </Button>
                                    {/*<Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                        <FaEraser /> Limpar Filtro
                                    </Button>*/}
                                </Col>
                                <Col sm={6} className="text-right">
                                    {'resultados' in this.state.listRegistros && (
                                    <Button type="button" variant="success" size="sm" className="ms-2" onClick={() => this.exportarExcel()}>
                                        <FaRegEdit className="me-2" /> Exportar Excel
                                    </Button>
                                    )}
                                </Col>
                            </Row>
                        </Form> 

                        <div className="mt-5">
                            { this.renderAbas() }
                        </div>

                        { this.renderResultados() }

                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Relatorios);